import { IRating } from "../customer-space/measure/measure-detail/measurre-evaluation/measure-evaluation.component";

export class RatingViewModel {
  private _data: IRating = {
    Id: undefined,
    measureId: "",
    comment: "",
    Impact: 0,
    Cost: 0,
    TotalScore: 0,
    Effort: 0,
    Benefit: 0,
    createdAt: undefined,
    personFullName: "",
    IdPerson: "",
  };

  constructor(data?: Partial<IRating>) {
    if (data) {
      Object.assign(this._data, data);
    }
  }

  get Id(): string | undefined {
    return this._data.Id;
  }
  set Id(value: string | undefined) {
    this._data.Id = value;
  }

  get measureId(): string {
    return this._data.measureId;
  }
  set measureId(value: string) {
    this._data.measureId = value;
  }

  get comment(): string {
    return this._data.comment;
  }
  set comment(value: string) {
    this._data.comment = value ?? "";
  }

  get Impact(): number {
    return this._data.Impact;
  }
  set Impact(value: number) {
    this._data.Impact = value;
  }

  get Cost(): number {
    return this._data.Cost;
  }
  set Cost(value: number) {
    this._data.Cost = value;
  }

  get TotalScore(): number {
    return this._data.TotalScore;
  }
  set TotalScore(value: number) {
    this._data.TotalScore = value;
  }

  get Effort(): number {
    return this._data.Effort;
  }
  set Effort(value: number) {
    this._data.Effort = value;
  }

  get Benefit(): number {
    return this._data.Benefit;
  }
  set Benefit(value: number) {
    this._data.Benefit = value;
  }

  get createdAt(): Date | undefined {
    return this._data.createdAt;
  }
  set createdAt(value: Date | undefined) {
    this._data.createdAt = value;
  }

  get personFullName(): string | undefined {
    return this._data.personFullName;
  }
  set personFullName(value: string | undefined) {
    this._data.personFullName = value ?? "";
  }

  get IdPerson(): string | undefined {
    return this._data.IdPerson;
  }
  set IdPerson(value: string | undefined) {
    this._data.IdPerson = value;
  }

  toDto(): IRating {
    return { ...this._data };
  }
}
